<template>
  <div>
    <a @click="previewInPanel" class="button is-info is-outlined" :class="{ 'is-loading': is_loading }" style="color: black;">preview_in_panel</a>
  </div>
</template>
<script>
export default {
  name: 'preview-company-in-panel',
  props: ['payload'],
  data () {
    return {
      is_loading: false
    }
  },
  methods: {
    previewInPanel () {
      this.is_loading = true
      this.$network_utils.getCompanyOneTimeCode({ company_id: this.payload.resource_id }).then(response => {
        this.is_loading = false
        let link = this.$settings.get({ path: 'company_panel_url' }) + 'set_view_mode?one_time_code=' + encodeURIComponent(response.code)
        this.$utils.openInNewTab(link)
      }).catch(() => {
        this.$utils.emit('show_toast', { text: 'ארעה שגיאה - כנראה שאין לחברה זו משתמש ב- Company Panel' })
        this.is_loading = false
      })
    }
  }
}
</script>
